import { render, staticRenderFns } from "./OrderFormPoint.vue?vue&type=template&id=07086a9c&scoped=true&"
import script from "./OrderFormPoint.vue?vue&type=script&lang=js&"
export * from "./OrderFormPoint.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormPoint.vue?vue&type=style&index=0&id=07086a9c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07086a9c",
  null
  
)

export default component.exports